<template>
  <section class="ai-manual-device">
    <div v-if="device" class="ai-original-preview" @contextmenu.capture.stop.prevent>
      <!-- inert隔离原卡片的点击、右键及键盘操作；独立按钮才打开手动入口。 -->
      <div inert aria-hidden="true"><original-device-card :key="previewRevision" :one-device="device" :disabled="true" /></div>
      <button class="ai-preview-hit" :disabled="busy || loading || !valid" :aria-busy="loading" :aria-label="'查看并手动控制 ' + item.title" @click="open">查看设备</button>
    </div>
    <div v-else class="ai-device-placeholder"><strong>{{ item.title }}</strong><small>{{ item.subtitle }}</small><p>{{ loading ? '正在读取…' : error || copy.deviceExpired }}</p></div>
    <button v-if="error && !device" class="ai-device-retry" :disabled="loading || busy || !valid" @click="refresh">重试</button>
    <p v-if="error && device" class="ai-device-error" role="status">{{ error }}</p>
    <div v-if="switchDevice" class="ai-switch-mask" @click.self="closeSwitch">
      <ai-switch-panel class="ai-switch-dialog" :title="item.title" :device="switchDevice" :busy="switchBusy" :error="switchError" @toggle="toggleSwitch" @close="closeSwitch" @keydown.native.esc="closeSwitch" @keydown.native.tab.prevent="cycleFocus" />
    </div>
  </section>
</template>
<script>
import OriginalDeviceCard from '@/components/content/contro-view/device-view/device-item-view.vue'
import AiSwitchPanel from './AiSwitchPanel.vue'
import { jieMianStateJudge } from '@/common/tool.js'
import { errorMessage } from '@/ai/services/api'
import { createManualDeviceReader, detachedDevice, MANUAL_TYPES, popupDevice, claimManualSurface, releaseManualSurface, confirmedManualPreview } from '@/ai/services/manual-device-bridge'

export default {
  components: { OriginalDeviceCard, AiSwitchPanel },
  inject: { aiPageState: { default: null } },
  computed: { copy() { return this.aiPageState ? this.aiPageState.copy : {} } },
  watch: { 'aiPageState.valid'(valid) { if (valid === false) this.invalidate() } },
  props: { item: {type: Object, required: true}, busy: Boolean },
  data: () => ({device:null,previewRevision:0,loading:false,error:'',switchDevice:null,switchBusy:false,switchError:'',ownsPopup:false,valid:true}),
  mounted() {
    this._reader = createManualDeviceReader()
    this._alive = true
    // The result carries a detached historical preview. Only opening/retry reads live details.
    if (this.item.preview) this.device = detachedDevice(this.item.preview)
    else if (this.item.readError) this.error = this.item.readError
    this._unwatch = this.$store.watch(s => this.ownsPopup ? s.publicinfo.objData : null, value => {
      if (this.ownsPopup && (!value || !value.productId)) { this.ownsPopup=false; releaseManualSurface(this); this.refresh({ fresh: true }) }
      else if(this.ownsPopup)this.syncPreview(value)
    }, { deep: true })

  },
  beforeDestroy() {
    this._alive=false
    if(this._unwatch)this._unwatch()
    this.disposePopup()
    if(this._reader)this._reader.close()
  },
  methods: {
    syncPreview(value) {
      if(!this._alive || !this.valid || !this._reader.valid())return
      const next=confirmedManualPreview(this.device,value)
      if(!next)return
      // 重新挂载只读卡片，避免原卡片的深度watch反向推送control2PageUpdata干扰弹窗。
      this.previewRevision++;this.device=next
    },
    invalidate() {
      this.valid=false;this.loading=false;this.disposePopup();if(this._reader)this._reader.close();this.device=null;
      this.error='账号或服务器已切换，请重新打开对话'
    },
    async refresh({ fresh = false } = {}) {
      if((this.loading && !fresh) || !this.valid || !this._alive)return
      const revision = this._readRevision = (this._readRevision || 0) + 1
      const current = () => this._alive && this.valid && revision === this._readRevision && this._reader.valid()
      this.loading=true;this.error=''
      try {const device=await this._reader.get(this.item.ref, { fresh });if(current()){this.previewRevision=(this.previewRevision||0)+1;this.device=device}}
      catch(error){if(current()){this.device=null;this.error=error.displayMessage || this.copy.deviceReadFailed || errorMessage(error)}}
      finally {if(this._alive && revision === this._readRevision)this.loading=false}
    },
    async open() {
      if(this.busy || this.loading || !this.valid)return
      const active=this.$store.state.publicinfo.objData
      if(active && active.productId){this.error='请先关闭当前控制面板';return}
      if(!claimManualSurface(this)){this.error='请先关闭当前控制面板';return}
      await this.refresh()
      if(!this.device || !this._alive || !this._reader.valid()){releaseManualSurface(this);return}
      const latest=this.$store.state.publicinfo.objData
      if(latest && latest.productId){releaseManualSurface(this);this.error='请先关闭当前控制面板';return}
      const kind=MANUAL_TYPES[this.device.productCode]
      if(!kind){releaseManualSurface(this);this.error='当前设备暂没有可复用的控制面板，请在原设备页面查看';return}
      if(kind==='switch') {
        this.switchDevice=detachedDevice(this.device)
        this.switchError=''
        this.$nextTick(()=>{const button=this.$el.querySelector('.ai-switch-dialog button');if(button)button.focus()})
        return
      }
      const data=popupDevice(this.device)
      this.$store.dispatch('asyUpdataobjData',data)
      this.ownsPopup=true
      this.$showControlToast('device',data)
    },
    cycleFocus(event) {
      const nodes=Array.from(this.$el.querySelectorAll('.ai-switch-dialog button:not(:disabled), .ai-switch-dialog [tabindex="0"]'))
      if(!nodes.length)return
      const index=nodes.indexOf(document.activeElement),next=(index+(event.shiftKey?-1:1)+nodes.length)%nodes.length
      nodes[next].focus()
    },
    async toggleSwitch() {
      const device=this.switchDevice
      if(this.switchBusy || !device || !this.valid || !this._reader.valid() || !jieMianStateJudge() || ![0,1].includes(device.openState))return
      this.switchBusy=true;this.switchError=''
      const current=()=>this._alive && this.valid && this._reader.valid() && this.switchDevice===device
      // 与原手动控制相同的接口和字段，AI桥接单独等待结果；不修改公共控制函数。
      const data={token:this.$store.state.token,deviceId:device.deviceId,openState:device.openState===1?0:1,password:''}
      for(const key of ['openStateValue','openStateValue1','openStateValue2','openStateValue3'])data[key]=device[key]
      try {
        const response=await this.$request({method:'post',url:'/device/updateDeiviceControl',data})
        if(!current())return
        if(!response || !response.data || Number(response.data.code)!==0){this.switchError=response && response.data && response.data.message || '操作未完成，请稍后重试';return}
        device.openState=data.openState
        this.syncPreview(device)
      } catch (_) { if(current()){device.openState=null;this.switchError='暂未确认结果，请关闭面板后查看最新状态'} }
      finally {this.switchBusy=false}
    },
    closeSwitch() {if(this.switchBusy)return;this.switchDevice=null;releaseManualSurface(this);this.refresh({ fresh: true });this.$nextTick(()=>{const button=this.$el.querySelector('.ai-preview-hit');if(button)button.focus()})},
    disposePopup() {
      releaseManualSurface(this)
      this.switchDevice=null
      if(this.ownsPopup) {
        const active=this.$store.state.publicinfo.objData
        if(active && this.device && active.productId===this.device.productId && active.regionId===this.device.regionId)this.$closeControlToast()
        this.ownsPopup=false
      }
    }
  }
}
</script>
<style scoped>
.ai-original-preview { position:relative;border-radius:14px;box-shadow:none; }
.ai-preview-hit { position:absolute;inset:0;width:100%;height:100%;border:0;background:transparent;border-radius:14px;cursor:pointer;font-size:0; }
.ai-preview-hit:focus-visible { outline:3px solid #7771ce;outline-offset:3px; }
.ai-preview-hit:disabled { cursor:default; }
.ai-device-retry {border:0;background:transparent;color:#125bc2;padding:8px;cursor:pointer;}
.ai-device-placeholder {box-sizing:border-box;min-height:120px;border:1px solid #e5e6ee;border-radius:14px;padding:14px;background:#f7f8fc;}
.ai-device-placeholder small {display:block;}
.ai-device-placeholder p,.ai-device-error {font-size:12px;color:#82768c;}
/* 低于原手动请求的公共loading(z-index:100)，不修改全局loading或其他面板层级。 */
.ai-switch-mask {position:fixed;inset:0;z-index:90;background:rgba(244,247,252,.1);display:flex;align-items:center;justify-content:center;padding:20px;}
</style>
